import type { DebounceSettings } from "lodash-es";
import { useEffect, useState } from "react";

import { useDebounceFn } from "../";

/**
 * @title useDebounce
 */
export type UseDebounce = <T>(
  /**
   * the value need to debounce
   */
  value: T,
  /**
   * wait time
   */
  wait?: number,
  /**
   * options passed to `lodash.debounce`
   */
  options?: DebounceSettings
) => T;

export const useDebounce: UseDebounce = <T>(
  value: T,
  wait?: number,
  options?: DebounceSettings
) => {
  const [debounced, setDebounced] = useState(value);

  const { run } = useDebounceFn(
    () => {
      setDebounced(value);
    },
    wait,
    options
  );

  useEffect(() => {
    run();
  }, [run, value]);

  return debounced;
};
